import { CncVpDash } from './VpDashPlayer';
import VideoAdRequest from './ads/videoAdRequest';
import { CncVpStreamPlayer } from './VpStreamPlayer';

const videoAdRequest = VideoAdRequest();
window.getBigPlayerTagUrl = videoAdRequest.getBigPlayerTagUrl.bind(
    videoAdRequest.getBigPlayerTagUrl,
);
window.getSmallPlayerTagUrl = videoAdRequest.getSmallPlayerTagUrl.bind(
    videoAdRequest.getSmallPlayerTagUrl,
);

window.CNC_vpDash = CncVpDash;
window.CNC_vpStreamPlayer = CncVpStreamPlayer;
